var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39514 5.85421C9.59041 5.65894 9.90699 5.65894 10.1023 5.8542L14.1451 9.8971C14.3404 10.0924 14.3404 10.4089 14.1451 10.6042L8.22848 16.5209C8.13471 16.6146 8.00753 16.6673 7.87492 16.6673H3.83203C3.55589 16.6673 3.33203 16.4435 3.33203 16.1673V12.1244C3.33203 11.9918 3.38471 11.8646 3.47848 11.7709L9.39514 5.85421ZM10.1023 8.27087C9.90699 8.07561 9.59041 8.07561 9.39514 8.27087L5.14514 12.5209C5.05138 12.6146 4.9987 12.7418 4.9987 12.8744V14.5007C4.9987 14.7768 5.22256 15.0007 5.4987 15.0007H7.12492C7.25753 15.0007 7.38471 14.948 7.47848 14.8542L11.7285 10.6042C11.9237 10.4089 11.9237 10.0924 11.7285 9.8971L10.1023 8.27087ZM11.6423 3.67059C11.8403 3.48363 12.1514 3.48945 12.3423 3.68369L16.318 7.73046C16.5104 7.92621 16.509 8.24038 16.3149 8.43442L15.6023 9.1471C15.407 9.34236 15.0904 9.34236 14.8951 9.1471L10.8625 5.11445C10.6633 4.91523 10.6679 4.59084 10.8727 4.39739L11.6423 3.67059Z",
    fill: "#5089FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiEditPen);
export default __webpack_public_path__ + "static/media/hi-edit-pen.388945f18ac4911551b9f5980173e653.svg";
export { ForwardRef as ReactComponent };